<template>
  <div class="flex flex-wrap gap-12">
    <RevButton
      v-if="actions.isSendMessageAllowed"
      data-qa="message-bar-answer-button"
      size="small"
      variant="secondary"
      @click="handleSendMessage"
    >
      {{ i18n(translations.sendMessage) }}
    </RevButton>

    <RevButton
      v-if="actions.isReplyToAgentAllowed"
      size="small"
      variant="secondary"
      @click="handleReplyToAgent"
    >
      {{ i18n(translations.replyToAgent) }}
    </RevButton>

    <OpenRequestButton
      v-if="actions.isOpenRequestAllowed"
      :customerRequestId
      @opened="send('REQUEST_OPENED')"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'

import type { ProductReturnState } from '~/api/care-folders/types/care-folder'
import type { OrderlineOpenTask } from '~/api/seller-after-sales/types'
import { ROUTE_NAMES } from '~/constants/routes'
import { useFormatDeadline } from '~/scopes/customer-care/pages/customer-care/composables/useFormatDeadline'

import type { Actions, MachineSend } from '../../../../ActionBar.machine.type'

import translations from './SecondaryActions.translations'
import OpenRequestButton from './components/OpenRequestButton/OpenRequestButton.vue'

const props = defineProps<{
  actions: Actions
  customerRequestId: number
  send: MachineSend
  mostUrgentTask?: OrderlineOpenTask
  productReturnState: ProductReturnState
}>()

const i18n = useI18n()
const tracking = useTracking()

function handleTrackClick(name: string) {
  tracking.trackClick({
    name,
    zone: 'asp-action-bar-action-list-step',
    customerRequestId: props.customerRequestId,
    pageType: ROUTE_NAMES.CUSTOMER_CARE.CUSTOMER_REQUEST,
    mostUrgentDeadline: props.mostUrgentTask
      ? useFormatDeadline(
          props.mostUrgentTask.deadline,
          props.mostUrgentTask.id,
        )
      : '',
    mostUrgentTaskType: props.mostUrgentTask?.status || '',
    productReturnState: props.productReturnState,
  })
}

function handleSendMessage() {
  props.send('START_SEND_MESSAGE_FLOW')
  handleTrackClick('send-message')
}

function handleReplyToAgent() {
  props.send('START_SEND_MESSAGE_FLOW')
  handleTrackClick('reply-to-agent')
}
</script>
